import React from 'react';

import { Footer, Header, PageLayout } from '../../components';
import PageContent from '../../features/MyFiles';

const MyFilesPage = () => {
  return (
    <>
      <Header />
      <PageLayout>
        <PageContent />
      </PageLayout>
      <Footer />
    </>
  );
};

export default MyFilesPage;
